import appLayout from '../layouts/AppLayout.vue'
export default [
  // USER
  {
    path: '/user/',
    name: 'user-list',
    component: () => import('../views/user/UserIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/user/create',
    name: 'user-create',
    component: () => import('../views/user/UserCreate.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/user/:id?',
    name: 'user-edit',
    component: () => import('../views/user/UserEdit.vue'),
    meta: { layout: appLayout }
  }
]
